import { createFeatureSelector, MemoizedSelector } from '@ngrx/store';
import { COMPARISON_FEATURE, ComparisonState, StateWithComparison } from '../comparison-state';

export const getComparisonState: MemoizedSelector<StateWithComparison, ComparisonState> =
  createFeatureSelector<ComparisonState>(COMPARISON_FEATURE);
